import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {Slider} from '@miblanchard/react-native-slider';

import theme from '../../style/theme';
import Text from '../ui-controls/Text';

import Thumb from './Thumb';

const SliderComponent = forwardRef(
  (
    {
      min = 0,
      max = 1000,
      initialLow = 250,
      initialHigh = 750,
      showBottomLabel = false,
      returnCallback = null,
    },
    ref,
  ) => {
    const [low, setLow] = useState(initialLow);
    const [high, setHigh] = useState(initialHigh);

    const handleValueChange = val => {
      setLow(val[0]);
      setHigh(val[1]);
      if (returnCallback) {
        returnCallback(val[0], val[1]);
      }
    };

    useImperativeHandle(ref, () => ({
      setValues: (newLow, newHigh) => {
        setLow(newLow);
        setHigh(newHigh);
      },
    }));

    return (
      <View>
        <View style={styles.container}>
          <Slider
            maximumValue={max}
            minimumTrackTintColor={theme.colour.background.general.primary}
            minimumValue={min}
            onValueChange={handleValueChange}
            renderThumbComponent={props => <Thumb {...props} />}
            step={5}
            value={[low, high]}
          />
        </View>
        {showBottomLabel ? (
          <View style={styles.labelRow}>
            <Text style={{fontSize: 12}}>${low}</Text>
            <Text style={{fontSize: 12}}>${high}</Text>
          </View>
        ) : null}
      </View>
    );
  },
);

export default SliderComponent;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    marginVertical: 4,
  },
  labelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 4,
    alignSelf: 'stretch',
  },
  rail: {
    flex: 1,
    height: 2,
    borderRadius: 2,
    backgroundColor: '#7f7f7f',
  },
  railSelected: {
    height: 4,
    backgroundColor: theme.colour.background.general.primary,
    borderRadius: 2,
  },
});
